import React, { Fragment, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { IconButton } from '@material-ui/core';

import { Edit2 } from 'react-feather';

import { GQLAccessoryInventory, GQLParty } from '@jewelutions/core-crm-server-api-client-domain';

import { LoadingSpinner, JwlTable } from '../../../../components';

import AccessoryInventoryUpdateDialog from '../AccessoryInventoryUpdateDialog/AccessoryInventoryUpdateDialog';
import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';
import { ProducerNavigation } from '../../navigation/ProducerNavigation';
import { successNotification } from '../../../../core/utils';
import { toast } from 'react-toastify';

interface IProps {
  party: GQLParty;
}

const AccessoriesInventory: React.FC<IProps> = ({ party }: IProps) => {
  const deliveryUnitId = ProducerNavigation.accessoriesInventoryList.paramsFromPath(useRouteMatch())
    .deliveryUnitId;
  const [selectedAccessoryInventory, selectAccessoryInventory] = useState<GQLAccessoryInventory>();
  const [isUpdateAccessoryInventoryDialogOpen, setUpdateAccessoryInventoryDialogOpen] = useState(false);
  const [filteredInventories, setFilteredInventories] = useState('');

  const {
    data,
    loading,
    refetch
  } = GQLOperationBuilder.deliveryUnit.getAccessoryInventorysByPartyAndDeliveryUnit({
    producerPartyId: party.id,
    deliveryUnitId: deliveryUnitId
  });
  const reloadData = async () => {
    return refetch();
  };

  if (loading) return <LoadingSpinner />;

  const columns = [
    'Accessory Name',
    'Size Type',
    'Material Type',
    'Plating Type',
    'Inventory Reference',
    'Actions'
  ];

  const handleFilterChange = (event: any) => setFilteredInventories(event.target.value);

  const getAccesoryInventoryRows = () => {
    return GQLOperationBuilder.deliveryUnit
      .accessoryInventorysFromResponse(data)
      .filter((accessoryInventory: any) => {
        return (
          accessoryInventory.accessoryTitle.en
            .toLowerCase()
            .includes(filteredInventories.toLowerCase().trim()) ||
          accessoryInventory.accessoryReference.accessoryConfiguration.sizeType
            .toLowerCase()
            .includes(filteredInventories.toLowerCase().trim())
        );
      })
      .sort((a1, a2) =>
        [
          a1.accessoryTitle.en!,
          a1.accessoryReference.accessoryConfiguration.sizeType,
          a1.accessoryReference.accessoryConfiguration.platingType
        ]
          .join()
          .localeCompare(
            [
              a2.accessoryTitle.en!,
              a2.accessoryReference.accessoryConfiguration.sizeType,
              a2.accessoryReference.accessoryConfiguration.platingType
            ].join()
          )
      )
      .map((accessoryInventory: any) => {
        return {
          id: accessoryInventory.id,
          cells: [
            accessoryInventory.accessoryTitle.en,
            accessoryInventory.accessoryReference.accessoryConfiguration.sizeType,
            accessoryInventory.accessoryReference.accessoryConfiguration.materialType,
            accessoryInventory.accessoryReference.accessoryConfiguration.platingType,
            accessoryInventory.inventoryReference,
            <IconButton aria-label="update" onClick={() => handleClickUpdateIcon(accessoryInventory)}>
              <Edit2 />
            </IconButton>
          ]
        };
      });
  };

  const handleClickUpdateIcon = (accessoryInventory: GQLAccessoryInventory) => {
    selectAccessoryInventory(accessoryInventory);
    setUpdateAccessoryInventoryDialogOpen(true);
  };

  return (
    <Fragment>
      <JwlTable
        title="Delivery Unit accessories inventory List"
        description={`The list of all current accessories in the inventory of the delivery unit of ${party.name}. The inventory reference must match exactly the inventory SKU (or some other unique identifier) in the inventory ERP of the delivery unit.`}
        columns={columns}
        rows={getAccesoryInventoryRows()}
        onFilterChange={handleFilterChange}
      />
      {isUpdateAccessoryInventoryDialogOpen && (
        <AccessoryInventoryUpdateDialog
          accessoryInventory={selectedAccessoryInventory!}
          onClose={(persisted: boolean) => {
            setUpdateAccessoryInventoryDialogOpen(false);
            if (persisted) {
              successNotification(toast, 'Accessory inventory data updated successfully', reloadData());
            }
          }}
        />
      )}
    </Fragment>
  );
};

export default AccessoriesInventory;
